let HrZoneNameMapper = {
        zone1: 'heart_zone_name.1',
        zone2: 'heart_zone_name.2',
        zone3: 'heart_zone_name.3',
        zone4: 'heart_zone_name.4',
        zone5: 'heart_zone_name.5'
    },
    PowerZoneNameMapper = {
        zone1: 'power_zone_name_1',
        zone2: 'power_zone_name_2',
        zone3: 'power_zone_name_3',
        zone4: 'power_zone_name_4',
        zone5: 'power_zone_name_5',
        zone6: 'power_zone_name_6',
        zone7: 'power_zone_name_7'
    },
    RunningPowerZoneNameMapper = {
        zone1: 'running_power_zone_name_1',
        zone2: 'running_power_zone_name_2',
        zone3: 'running_power_zone_name_3',
        zone4: 'running_power_zone_name_4',
        zone5: 'running_power_zone_name_5'
    };

function createZoneObject(collection, nameMapper, isBackbone) {
    let key = '',
        zoneBoundary = '',
        nextBoundaryValue,
        zone,
        nextZone,
        zones = {};

    if (collection) {
        for (let c = 0, len = collection.length; c < len; c += 1) {
            if (collection[c]) {
                nextBoundaryValue = null;
                zone = collection[c];
                if (isBackbone) {
                    key = 'zone' + zone.get('zoneNumber');
                    zoneBoundary = zone.get('zoneLowBoundary');
                } else {
                    key = 'zone' + zone.zoneNumber;
                    zoneBoundary = zone.zoneLowBoundary;
                }
                nextZone = collection[c + 1];

                if (nextZone) {
                    if (isBackbone) {
                        nextBoundaryValue = nextZone.get('zoneLowBoundary') - 1;
                    } else {
                        nextBoundaryValue = nextZone.zoneLowBoundary - 1;
                    }
                }

                zones[key] = {
                    name: nameMapper[key],
                    range: zoneBoundary
                        ? nextBoundaryValue
                            ? '(' + zoneBoundary + ' - ' + nextBoundaryValue + ')'
                            : '( > ' + zoneBoundary + ')'
                        : ''
                };
            }
        }
    }
    return zones;
}

var timeInZoneUtil = function(collection, nameMapper, isBackbone) {
    if (!collection) {
        throw 'collection is required';
    }
    this.zones = createZoneObject(collection, nameMapper, isBackbone);
};

timeInZoneUtil.prototype.getZones = function() {
    return this.zones;
};

timeInZoneUtil.prototype.getZone = function(zoneNumber) {
    if (zoneNumber) {
        return this.zones['zone' + zoneNumber];
    }
    return null;
};

timeInZoneUtil.HrZoneNameMapper = HrZoneNameMapper;
timeInZoneUtil.PowerZoneNameMapper = PowerZoneNameMapper;
timeInZoneUtil.RunningPowerZoneNameMapper = RunningPowerZoneNameMapper;

export default timeInZoneUtil;
